'use client';

import { useCallback } from 'react';
import Cookies from 'js-cookie';
import { shared } from '../config';
import { CUSTOMER_ENDPOINT } from '../customer/constants';

export const useMigratedCustomer = storedSessionUser => {
  const isShopifyUser = storedSessionUser?.user?.shopify_user;
  const abUserId = storedSessionUser?.id || Cookies.get('anonymousVisitorId');
  const fetchCustomer = useCallback(async () => {
    const response = await fetch(
      `${shared.API_HTTP_SCHEME}://${shared.API_BASE_URL}${CUSTOMER_ENDPOINT}${storedSessionUser?.id}/`,
      {
        headers: {
          Authorization: `Bearer ${storedSessionUser?.access_token}`,
          // the BE will reject any calls without a valid x-ollie-user-id property
          ...(isShopifyUser && {
            'x-ollie-user-id': `${storedSessionUser?.shopify_id}`,
          }),
          ...(abUserId && {
            'x-ab-user-id': `${abUserId}`,
          }),
        },
      },
    );
    const customerJson = await response.json();
    return customerJson;
  }, [storedSessionUser, isShopifyUser, abUserId]);

  return { fetchCustomer };
};
